/**
 *  商品配置页 code 参数检查，无 code 时跳转首页
 */
export default ({ query, redirect }) => {
  if (!query.code) {
    return redirect('/')
  }
}
